import get from 'lodash/get';
import PropTypes from 'prop-types';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import AppDashboard from '../AppDashboard';
import SessionTypeForm from '../../components/scheduling/SessionTypeForm';
import {useGetCurrentProviderQuery} from '../../redux/services/providerApi';
import {useCreateSessionTypeMutation} from '../../redux/services/sessionTypeApi';
import useError from '../../hooks/useError';

const handleSubmit = ({
  createSessionTypeMutation,
  setError,
  onBack,
  providerId
}) => async formData => {
  const res = await createSessionTypeMutation(formData);
  if (res?.error) {
    const message = res?.error?.data?.errors?.[0];
    setError({message});
  } else {
    onBack();
  }
};

const NewProviderSessionTypePage = props => {
  const navigate = useNavigate();
  const providerQuery = useGetCurrentProviderQuery();
  const [createSessionTypeMutation] = useCreateSessionTypeMutation();
  const errors = useError();
  const setError = errors.create;
  const providerId = get(providerQuery, 'data.id', null);
  const onBack = () => navigate(`/providers/${providerId}/session-types/list`);
  const onSubmit = handleSubmit({
    createSessionTypeMutation,
    providerId,
    setError,
    onBack,
  });
  const childProps = {
    ...props,
    setError: err => errors.create(err),
    isEditingExistingSessionType: false,
    onCancel: onBack,
    onSubmit: onSubmit,
  };
  return (
    <AppDashboard
      title='Session Types'
      onBack={onBack}
    >
      <SessionTypeForm {...childProps } />
    </AppDashboard>
  );
};

NewProviderSessionTypePage.defaultProps = {
};

NewProviderSessionTypePage.propTypes = {
};

export default NewProviderSessionTypePage;
